var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M39 0c2.48 0 4.599.88 6.36 2.64C47.12 4.402 48 6.52 48 9v30c0 2.48-.88 4.599-2.64 6.36C43.598 47.12 41.48 48 39 48h-5.875V29.406h6.219l.937-7.25h-7.156v-4.625c0-1.166.245-2.041.734-2.625.49-.583 1.443-.875 2.86-.875L40.53 14V7.531c-1.312-.187-3.166-.281-5.562-.281-2.834 0-5.1.833-6.797 2.5-1.698 1.667-2.547 4.02-2.547 7.063v5.343h-6.25v7.25h6.25V48H9c-2.48 0-4.599-.88-6.36-2.64C.88 43.598 0 41.48 0 39V9c0-2.48.88-4.599 2.64-6.36C4.402.88 6.52 0 9 0h30z","fill":"#000"}));
}

Facebook.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
